import { render, staticRenderFns } from "./videoDataTable.vue?vue&type=template&id=110a5d66"
import script from "./videoDataTable.vue?vue&type=script&lang=js"
export * from "./videoDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports